import AuthService from '../../../services/authService';
import UserService from '../../user/services/userService';
import ForgotPasswordController from "./forgotPasswordController";

import _ from './forgotPassword.scss';

const ForgotPassword = {
    template: require('./forgotPasswordView.html'),
    controller: ForgotPasswordController
};

export default angular.module('app.forgotPassword', [])
    .component('forgotPassword', ForgotPassword)
    .service("AuthService", AuthService)
    .service("UserService", UserService)
    .name;



// WEBPACK FOOTER //
// ./src/app/pages/login/forgotPassword/forgotPasswordComponent.js